import { render, staticRenderFns } from "./settledTab.vue?vue&type=template&id=6730af6f&scoped=true"
import script from "./settledTab.vue?vue&type=script&lang=js"
export * from "./settledTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6730af6f",
  null
  
)

export default component.exports